module.exports = __webpack_public_path__ + "static/media/3. Speaker Eva Gutierrez.c1bf4228.png";